import { ENV_CLIENT_ID } from '@/configs/environment';
import axios from 'axios';

const AUTH_URL = 'https://twitter.com/i/oauth2/authorize';

const exchangeCodeLine = async (code: string) => {
    if (!code) return null;
    const body = {
        'grant_type': 'authorization_code',
        'code': code,
        'redirect_uri': ENV_CLIENT_ID.redirectUrl || '',
        'client_id': ENV_CLIENT_ID.lineClientId || '',
        'client_secret': ENV_CLIENT_ID.lineClientSecret || ''
    };
    try {
        const response = await axios.post('https://api.line.me/oauth2/v2.1/token', new URLSearchParams(body), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
        if (response && response.data.id_token) {
            const id_token = response.data.id_token;
            return id_token;
        } else return null;
    } catch (error) {
        return null;
    }
};

const getTwitterAuthUrl = (state: string): string => {
    const scope = encodeURIComponent('tweet.read users.read offline.access');
    return `${AUTH_URL}?response_type=code&client_id=${ENV_CLIENT_ID.xClientId}&redirect_uri=${encodeURIComponent(
        ENV_CLIENT_ID.redirectUrl || ''
    )}&scope=${scope}&state=${state}&code_challenge=challenge&code_challenge_method=plain&action=login`;
};

const fetchInfoUserGoogle = async (code: string): Promise<string | null> => {
    if (!code) return null;
    const tokenUrl = 'https://oauth2.googleapis.com/token';
    try {
        const tokenResponse = await axios.post(tokenUrl, null, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            params: {
                code: code,
                client_id: ENV_CLIENT_ID.googleClientId || '',
                client_secret: ENV_CLIENT_ID.googleClientSecret || '',
                redirect_uri: ENV_CLIENT_ID.redirectUrl || '',
                grant_type: 'authorization_code'
            }
        });

        const { access_token } = tokenResponse.data;
        const email = await fetchUserProfileGoogle(access_token);
        return email;
    } catch (error) {
        console.error('Error fetching Google token or user info:', error);
        return null;
    }
};

const fetchUserProfileGoogle = async (accessToken: string): Promise<string | null> => {
    const userInfoUrl = 'https://www.googleapis.com/oauth2/v3/userinfo';
    try {
        const userResponse = await axios.get(userInfoUrl, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });

        const { email } = userResponse.data;
        return email || null;
    } catch (error) {
        console.error('Error fetching user profile from Google:', error);
        return null;
    }
};

const LoginService = {
    exchangeCodeLine,
    getTwitterAuthUrl,
    fetchInfoUserGoogle
};
export default LoginService;
